import { useEffect, useState } from 'react';
import PropTypes from 'prop-types';

const CreatedByCell = ({ owner }) => {
  const fullName = typeof owner?.full_name === 'string' ? owner.full_name.trim() : '';
  const email = typeof owner?.email === 'string' ? owner.email.trim() : '';
  const profilePhoto = typeof owner?.profile_photo === 'string' ? owner.profile_photo.trim() : '';
  const displayName = fullName || email || 'Member';
  const nameForInitial = fullName || email;
  const initial = nameForInitial ? nameForInitial.charAt(0).toUpperCase() : '';

  const [photoFailed, setPhotoFailed] = useState(false);

  useEffect(() => {
    setPhotoFailed(false);
  }, [profilePhoto]);

  const showPhoto = Boolean(profilePhoto) && !photoFailed;

  return (
    <div className="flex flex-row items-center p-0 gap-10 min-w-0 ml-12">
      {showPhoto && (
        <img
          src={profilePhoto}
          alt="profile"
          className="w-6 h-6 rounded-full object-cover flex-shrink-0"
          onError={() => setPhotoFailed(true)}
        />
      )}
      {!showPhoto && initial && (
        <div
          className="w-6 h-6 rounded-full bg-figma-gray-200 flex items-center justify-center flex-shrink-0"
          aria-hidden="true"
        >
          <span className="font-inter font-medium text-xs leading-3 text-center text-figma-gray-900">
            {initial}
          </span>
        </div>
      )}
      <span
        className="font-inter font-medium text-sm leading-5 text-figma-gray-900 truncate"
        title={displayName}
      >
        {displayName}
      </span>
    </div>
  );
};

CreatedByCell.propTypes = {
  owner: PropTypes.shape({
    full_name: PropTypes.string,
    email: PropTypes.string,
    profile_photo: PropTypes.string,
  }),
};

CreatedByCell.defaultProps = {
  owner: null,
};

export default CreatedByCell;
